import React from 'react';
import { ArrowRight } from 'lucide-react';
import images from '../data/images.json';

const CTA = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={images.about.truck}
          alt="Foody Burger 49"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-neutral-900/95 via-neutral-900/80 to-neutral-900/95"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-red-600/20 backdrop-blur-sm border border-red-600/30 rounded-full px-6 py-2">
            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
            <span className="text-red-400 font-semibold text-sm tracking-wider">
              DISPONIBILE PER COLLABORAZIONI
            </span>
          </div>

          {/* Headline */}
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-50 leading-tight">
            Porta il tuo brand
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-amber-500">
              su strada
            </span>
          </h2>

          {/* Description */}
          <p className="text-xl text-amber-100/80 max-w-2xl mx-auto leading-relaxed">
            Foody Burger 49 è disponibile per collaborazioni, tour brandizzati e campagne promozionali in tutta Europa.
          </p>

          {/* CTA Button */}
          <div className="pt-4">
            <button
              onClick={scrollToContact}
              className="group bg-red-600 hover:bg-red-700 text-white px-10 py-5 rounded-lg font-bold text-xl transition-all duration-300 shadow-2xl hover:shadow-red-600/50 hover:scale-105 flex items-center space-x-3 mx-auto"
            >
              <span>Richiedi una proposta personalizzata</span>
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
